import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'

const GET_TAG_OPTIONS = gql`
  query getTags {
    getTags {
      certificates {
        keyName
        values
      }
      languages {
        keyName
        values
      }
      industries {
        keyName
        values
      }
      software {
        keyName
        values
      }
      skills {
        keyName
        values
      }
    }
  }
`

export default () => {
  const { loading, error, data } = useQuery(GET_TAG_OPTIONS)
  return { loading, error, data }
}
